import type { ComponentProps } from "react";

export function Sessions(props: ComponentProps<"svg">) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 25 25"
			fill="none"
			{...props}
		>
			<path
				stroke="currentColor"
				strokeWidth={1.5}
				d="M4.707 14.655v-4.169a4 4 0 0 1 4-4h7.062a4 4 0 0 1 4 4v3.18a4 4 0 0 1-4 4h-3.12a1 1 0 0 0-.703.29l-2.622 2.595a.5.5 0 0 1-.851-.356V18.42a.753.753 0 0 0-.754-.753 3.012 3.012 0 0 1-3.012-3.013Z"
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="bevel"
				strokeWidth={1.5}
				d="M9.727 10.741h5.022M9.727 13.78h3.348"
			/>
		</svg>
	);
}
